<template>
  <div
    v-if="applicationReady"
    class="questionnaire"
  >
    <div class="questionnaire-top">
      <b-row>
        <b-col
          v-if="!formSubmitted"
          cols="12"
        >
          <b-row>
            <b-col
              cols="12"
              class="question question-margin-bottom"
            >
              <h1>
                Enter first time visitor information
              </h1>
            </b-col>
          </b-row>

          <b-row
            v-if="currentPage === 1 && $v.formAnswers.pageOne.$error"
            class="question-errors"
          >
            <b-col
              cols="12"
              class="pb-3"
            >
              <div
                v-if="!$v.formAnswers.pageOne.firstName.required"
                class="invalid-feedback"
              >
                <h3>First name is required</h3>
              </div>
              <div
                v-if="!$v.formAnswers.pageOne.lastName.required"
                class="invalid-feedback"
              >
                <h3>Last name is required</h3>
              </div>
              <div
                v-if="!$v.formAnswers.pageOne.email.required"
                class="invalid-feedback"
              >
                <h3>Email address is required</h3>
              </div>
              <div
                v-if="!$v.formAnswers.pageOne.email.email"
                class="invalid-feedback"
              >
                <h3>Invalid email address</h3>
              </div>
              <div
                v-if="!$v.formAnswers.pageOne.phone.required"
                class="invalid-feedback"
              >
                <h3>Phone number is required</h3>
              </div>
              <div
                v-if="!$v.formAnswers.pageOne.visitorType.required"
                class="invalid-feedback"
              >
                <h3>Visitor type is required</h3>
              </div>
            </b-col>
          </b-row>

          <b-row
            v-if="currentPage === 2 && $v.formAnswers.pageTwo.$error"
            class="question-errors"
          >
            <b-col
              cols="12"
              class="pb-3"
            >
              <div
                v-if="!$v.formAnswers.pageTwo.address_1.required"
                class="invalid-feedback"
              >
                <h3>Address is required</h3>
              </div>
              <div
                v-if="!$v.formAnswers.pageTwo.city.required"
                class="invalid-feedback"
              >
                <h3>City is required</h3>
              </div>
              <div
                v-if="!$v.formAnswers.pageTwo.state.required || !$v.formAnswers.pageTwo.state.notDisabled"
                class="invalid-feedback"
              >
                <h3>State is required</h3>
              </div>
              <div
                v-if="!$v.formAnswers.pageTwo.zip.required"
                class="invalid-feedback"
              >
                <h3>Zip is required</h3>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <smooth-reflow>
                <b-form @submit.prevent>
                  <b-row v-if="currentPage === 1">
                    <b-col cols="12">
                      <b-form-row class="question-answer">
                        <b-col
                          cols="12"
                          md="6"
                          class="pb-5"
                        >
                          <b-form-input
                            size="lg"
                            type="text"
                            v-model="formAnswers.pageOne.firstName"
                            autofocus="autofocus"
                            placeholder="First Name"
                          />
                          <!-- :state="isMissing($v.formAnswers.pageOne.firstName.$error)" -->
                        </b-col>

                        <b-col
                          cols="12"
                          md="6"
                          class="pb-5"
                        >
                          <b-form-input
                            size="lg"
                            type="text"
                            v-model="formAnswers.pageOne.lastName"
                            placeholder="Last Name"
                          />
                          <!-- :state="isMissing($v.formAnswers.pageOne.lastName.$error)" -->
                        </b-col>
                      </b-form-row>

                      <b-form-row class="question-answer">
                        <b-col
                          cols="12"
                          md="6"
                          class="pb-3"
                        >
                          <b-form-input
                            size="lg"
                            type="text"
                            v-model="formAnswers.pageOne.email"
                            placeholder="Email"
                          />
                          <!-- :state="isMissing($v.formAnswers.pageOne.email.$error)" -->
                        </b-col>

                        <b-col
                          cols="12"
                          md="6"
                          class="pb-3"
                        >
                          <cleave
                            v-model="formAnswers.pageOne.phone"
                            :options="masks.phone"
                            class="form-control form-control-lg"
                            @keyup.native.enter="nextPage"
                            placeholder="Phone"
                          />
                          <!-- :state="isMissing($v.formAnswers.pageOne.phone.$error)" -->
                        </b-col>
                        <b-col
                          cols="12"
                          md="6"
                          class="pb-3"
                        >
                          <b-form-select
                            size="lg"
                            v-model="formAnswers.pageOne.visitorType"
                            :options="[
                              { value: null, text: 'Visitor Type '},
                              { value: 8, text: 'Family/friend' },
                              { value: 1, text: 'MD/DPM/NP/PA/OD' },
                              { value: 2, text: 'Home Health' },
                              { value: 3, text: 'Hospice' },
                              { value: 4, text: 'PT/OT/ST – Part B only' },
                              { value: 5, text: 'Agency Staff' },
                              { value: 6, text: 'Private Duty Caregiver' },
                              { value: 7, text: 'Other' }
                            ]"
                          />
                          <!-- :state="isMissing($v.formAnswers.pageOne.phone.$error)" -->
                        </b-col>
                      </b-form-row>
                    </b-col>
                  </b-row>

                  <b-row v-if="currentPage === 2">
                    <b-col cols="12">
                      <b-form-row class="question-answer">
                        <b-col
                          cols="12"
                          class="pb-5"
                        >
                          <b-form-input
                            size="lg"
                            type="text"
                            v-model="formAnswers.pageTwo.address_1"
                            autofocus="autofocus"
                            placeholder="Address Line 1"
                          />
                          <!-- :state="isMissing($v.formAnswers.pageTwo.address_1.$error)" -->
                        </b-col>
                      </b-form-row>

                      <b-form-row class="question-answer">
                        <b-col
                          cols="12"
                          class="pb-5"
                        >
                          <b-form-input
                            size="lg"
                            type="text"
                            v-model="formAnswers.pageTwo.address_2"
                            placeholder="Address Line 2"
                          />
                        </b-col>
                      </b-form-row>

                      <b-form-row class="question-answer">
                        <b-col
                          cols="12"
                          md="6"
                          class="pb-3"
                        >
                          <b-form-input
                            size="lg"
                            type="text"
                            v-model="formAnswers.pageTwo.city"
                            placeholder="City"
                          />
                          <!-- :state="isMissing($v.formAnswers.pageTwo.city.$error)" -->
                        </b-col>

                        <b-col
                          cols="6"
                          md="3"
                          class="pb-3"
                        >
                          <b-form-select
                            size="lg"
                            v-model="formAnswers.pageTwo.state"
                            :options="states"
                            class="visitor-state"
                          />
                          <!-- :state="isMissing($v.formAnswers.pageTwo.state.$error)" -->
                        </b-col>

                        <b-col
                          cols="6"
                          md="3"
                          class="pb-3"
                        >
                          <b-form-input
                            size="lg"
                            type="text"
                            v-model="formAnswers.pageTwo.zip"
                            placeholder="Zip"
                            @keyup.enter="nextPage"
                          />
                          <!-- :state="isMissing($v.formAnswers.pageTwo.zip.$error)" -->
                        </b-col>
                      </b-form-row>
                    </b-col>
                  </b-row>
                </b-form>
              </smooth-reflow>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>

    <div class="questionnaire-bottom">
      <b-row>
        <b-col cols="12">
          <b-form>
            <b-form-row class="justify-content-center no-gutters">
              <b-col
                v-if="!formSubmitted"
                cols="6"
                sm="4"
                class="pb-3 question-navigation order-md-1"
              >
                <b-button
                  @click="goHome"
                  class="btn-green btn-nav"
                >
                  <img
                    src="../assets/home-icon.png"
                  >
                </b-button>
              </b-col>

              <b-col
                v-if="!formSubmitted"
                cols="6"
                sm="4"
                class="pb-3 question-navigation order-md-2"
              >
                <b-button
                  @click="previousPage"
                  :disabled="canGoBack"
                  class="btn-green btn-nav"
                >
                  <b-icon-caret-left-fill />
                </b-button>
              </b-col>

              <b-col
                v-if="canGoForward"
                cols="6"
                sm="4"
                class="pb-3 question-navigation order-md-3"
              >
                <b-button
                  @click="nextPage"
                  class="btn-green btn-nav"
                >
                  <b-icon-caret-right-fill />
                </b-button>
              </b-col>

              <b-col
                v-if="!canGoForward && !formSubmitted"
                cols="6"
                sm="4"
                class="pb-3 question-navigation order-md-3"
              >
                <b-button
                  @click="nextPage"
                  class="btn-green btn-nav"
                >
                  Submit
                </b-button>
              </b-col>

              <b-col
                v-if="formSubmitted"
                cols="6"
                sm="4"
                class="pb-3 question-navigation"
              >
                <b-button
                  @click="goHome"
                  class="btn-green btn-nav"
                >
                  <img
                    src="../assets/home-icon.png"
                    class="screening-icon"
                  >
                </b-button>
              </b-col>

              <b-col
                v-if="formSubmitted"
                cols="6"
                sm="4"
                class="pb-3 question-navigation"
              >
                <b-button
                  @click="logout"
                  class="btn-green btn-nav"
                >
                  <img
                    src="../assets/log-out-icon-white.png"
                    class="icon-with-text"
                  >
                  Log out
                </b-button>
              </b-col>
            </b-form-row>
          </b-form>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import { between, decimal, required } from 'vuelidate/lib/validators'
import { email, required } from 'vuelidate/lib/validators'
import { notDisabled } from '../plugins/validators'
import merge from 'lodash.merge'
import Cleave from 'vue-cleave-component'
import 'cleave.js/dist/addons/cleave-phone.us'
import { states } from '../consts'
import uuid from 'uuid'

export default {
  middleware: 'auth',
  name: 'FirstTimeVisitor',
  components: {
    'smooth-reflow': () => import(/* webpackPrefetch: true */ /* webpackChunkName: "smooth-reflow" */ '../components/SmoothReflow'),
    Cleave
  },
  data () {
    return {
      currentPage: 1,
      formSubmitted: false,
      states: [
        {
          value: 'disabled',
          text: 'State',
          disabled: true
        }
      ],
      formAnswers: {
        pageOne: {
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          visitorType: null
        },
        pageTwo: {
          address_1: '',
          address_2: '',
          city: '',
          state: 'disabled',
          zip: ''
        }
      }
    }
  },
  validations: {
    formAnswers: {
      pageOne: {
        firstName: {
          required
        },
        lastName: {
          required
        },
        email: {
          required,
          email
        },
        phone: {
          required
        },
        visitorType: {
          required
        }
      },
      pageTwo: {
        address_1: {
          required
        },
        city: {
          required
        },
        state: {
          required,
          notDisabled

        },
        zip: {
          required
        }
      }
    }
  },
  created () {
    this.states.push(...states)
  },
  computed: {
    ...mapGetters([
      'applicationReady'
    ]),
    ...mapGetters({
      masks: 'forms/masks'
    }),
    canGoBack () {
      return this.currentPage === 1
    },
    canGoForward () {
      if (this.collectAddress) {
        return this.currentPage < 2
      }
      return false
    },
    collectAddress () {
      return (this.userState === 'OH' || this.userState === 'PA')
    }
  },
  methods: {
    ...mapActions([
      'setVisitorInformation'
    ]),
    nextPage () {
      if (this.currentPage === 1) {
        this.$v.formAnswers.pageOne.$touch()
        if (!this.$v.formAnswers.pageOne.$invalid) {
          if (this.formAnswers.pageOne.visitorType === null) return
          if (this.collectAddress) {
            this.currentPage++
          } else {
            this.submitForm()
          }
        }
      } else {
        this.$v.formAnswers.pageTwo.$touch()
        if (!this.$v.formAnswers.pageTwo.$invalid) {
          this.submitForm()
        }
      }
    },
    previousPage () {
      if (this.currentPage === 2) {
        this.$v.formAnswers.pageTwo.$reset()
      }
      this.currentPage--
    },
    submitForm () {
      if (!this.collectAddress) {
        this.formAnswers.pageTwo.state = ''
      }
      const mergedDetails = merge(this.formAnswers.pageOne, this.formAnswers.pageTwo)
      mergedDetails.id = uuid()
      this.setVisitorInformation(mergedDetails)
      if (this.isSelfMode) {
        const itemNameParts = [this.formAnswers.pageOne.firstName, this.formAnswers.pageOne.lastName]
        const itemName = `${this.formAnswers.pageOne.firstName} ${this.formAnswers.pageOne.lastName}`
        const visitor = {
          itemId: 0,
          itemName,
          itemNameParts,
          searchData: `${this.formAnswers.pageOne.firstName} ${this.formAnswers.pageOne.lastName} - NewVisitor`,
          type: 'new',
          visitorType: this.formAnswers.pageOne.visitorType,
          visitor: { ...mergedDetails, search: itemName }
        }
        this.$store.dispatch('addNewVisitor', visitor)
        console.log('NEW VISITOR')
        console.log(visitor)
        this.$router.push('visitor-guidelines')
      } else {
        this.$router.push({ name: 'available-forms' })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.questionnaire-bottom {
  text-align: center;
}
</style>
